export function getTrayectosSorted(meta) {
  return [...meta.trayectos].sort((a, b) => a.row - b.row);
}

export function getTrayectoById(meta, trayectoId) {
  return meta.trayectos.find((t) => t.id === trayectoId);
}

export function getTrayectoRowIndex(meta, trayectoId) {
  const sorted = getTrayectosSorted(meta);
  return sorted.findIndex((t) => t.id === trayectoId);
}

export function sortMaterias(materias, meta) {
  return [...materias].sort((a, b) => {
    if (a.Semestre !== b.Semestre) return a.Semestre - b.Semestre;
    const rowA = getTrayectoRowIndex(meta, a.Trayecto);
    const rowB = getTrayectoRowIndex(meta, b.Trayecto);
    if (rowA !== rowB) return rowA - rowB;
    return a.Orden - b.Orden;
  });
}

export function computeMallaTotals(materias) {
  return materias.reduce(
    (acc, m) => ({
      materias: acc.materias + 1,
      horas: acc.horas + (m.Horas || 0),
      creditos: acc.creditos + (m.Creditos || 0),
    }),
    { materias: 0, horas: 0, creditos: 0 }
  );
}

export function groupMateriasBySemestre(materias) {
  return materias.reduce((acc, m) => {
    const key = m.Semestre;
    if (!acc[key]) acc[key] = [];
    acc[key].push(m);
    return acc;
  }, {});
}

export function formatSemestreLabel(semestre) {
  return `Sem ${String(semestre).padStart(2, "0")}`;
}
